import { render, staticRenderFns } from "./famousDoctor.vue?vue&type=template&id=6a2ce50c&scoped=true&"
import script from "./famousDoctor.vue?vue&type=script&lang=js&"
export * from "./famousDoctor.vue?vue&type=script&lang=js&"
import style0 from "./famousDoctor.vue?vue&type=style&index=0&id=6a2ce50c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ce50c",
  null
  
)

export default component.exports